function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(250, 250, 250)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'gron': 'url("//hyggehusmobler.com/cdn/shop/files/Green_120x.jpg?v=14261256340693214177")','natur': 'url("//hyggehusmobler.com/cdn/shop/files/Natural_120x.jpg?v=329528298923267061")','rokt': 'url("//hyggehusmobler.com/cdn/shop/files/Smoked_120x.jpg?v=15946126201418781624")','svart': 'url("//hyggehusmobler.com/cdn/shop/files/Black_120x.jpg?v=6141810654949836425")','sand': 'url("//hyggehusmobler.com/cdn/shop/files/Sand_120x.jpg?v=11082952001928285989")','valnot': 'url("//hyggehusmobler.com/cdn/shop/files/Walnut_120x.jpg?v=2803293464118615217")','brun': 'url("//hyggehusmobler.com/cdn/shop/files/Brown_120x.jpg?v=12961450351469004648")','morkbrun': 'url("//hyggehusmobler.com/cdn/shop/files/Dark_brown_120x.jpg?v=13546883428872484290")','massing': 'url("//hyggehusmobler.com/cdn/shop/files/Brass_120x.jpg?v=5707653121892285780")','silver': 'url("//hyggehusmobler.com/cdn/shop/files/Silver_120x.jpg?v=9310051197849856714")','morkgra': 'url("//hyggehusmobler.com/cdn/shop/files/Dark_grey_120x.jpg?v=14695426372989578500")','olivgron': 'url("//hyggehusmobler.com/cdn/shop/files/Olive_green_120x.jpg?v=17949714512467947538")',};

    this.triggers = ['color','colour','couleur','farbe','cor','färg',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
